import axios from 'axios';
import queryString from 'query-string';
import { getApiV2BaseUrl } from '../config/brand';

const baseURL = import.meta.env.MODE === 'development'
  ? 'http://localhost:5001/api/v1/'
  : '/api/v1/';

/** V2 base: same-origin on localhost dev (Vite → Node); see vite.config `proxy['/api/v2']`. */
const baseURLV2 = (() => {
  if (import.meta.env.MODE !== 'development') return '/api/v2/';
  if (typeof window !== 'undefined'
    && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) {
    const u = getApiV2BaseUrl();
    return `${u.replace(/\/$/, '')}/`;
  }
  return 'http://localhost:5001/api/v2/';
})();

const axiosClient = axios.create({
  baseURL,
  withCredentials: true,
  paramsSerializer: { serialize: (params) => queryString.stringify(params) },
});

/** V2 flows/apps CRUD — see server/routes/v2 */
export const axiosClientV2 = axios.create({
  baseURL: baseURLV2,
  withCredentials: true,
  paramsSerializer: { serialize: (params) => queryString.stringify(params) },
});

axiosClientV2.interceptors.request.use((config) => {
  const token = localStorage.getItem('tkn');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  config.headers['X-UI-Version'] = config.headers['X-UI-Version'] || 'v2';
  return config;
});

axiosClientV2.interceptors.response.use(
  (res) => (res?.data ? res.data : res),
  (err) => Promise.reject(err?.response?.data || { message: 'Unknown error' }),
);

/** Python `/api/v1/*` routes; in production they are reached through Node's authenticated proxy. */
const PYTHON_API_BASE = import.meta.env.MODE === 'development'
  ? 'http://localhost:8001/api/v1/'
  : '/api/v1/langgraph-proxy/api/v1/';

export const mcpClient = axios.create({
  baseURL: PYTHON_API_BASE,
  withCredentials: true,
  paramsSerializer: { serialize: (params) => queryString.stringify(params) },
});

mcpClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('tkn');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

mcpClient.interceptors.response.use(
  (res) => (res?.data ? res.data : res),
  (err) => Promise.reject(err?.response?.data || { message: 'Unknown error' }),
);

axiosClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('tkn');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

axiosClient.interceptors.response.use(
  (res) => (res?.data ? res.data : res),
  (err) => Promise.reject(err?.response?.data || { message: 'Unknown error' }),
);

export const pythonClient = axios.create({
  baseURL: PYTHON_API_BASE,
  withCredentials: true,
  paramsSerializer: { serialize: (params) => queryString.stringify(params) },
});

pythonClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('tkn');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

pythonClient.interceptors.response.use(
  (res) => (res?.data ? res.data : res),
  (err) => Promise.reject(err?.response?.data || { message: 'Unknown error' }),
);

export default axiosClient;
